
let apiPath = 'https://mais-atacado-backend.somalabs.com.br';

// eslint-disable-next-line no-restricted-globals
// let apiPath = `${location.origin}:8080`;

let setUser = undefined;

const loginAttempt = async (user) => {
  // this.state.login, this.state.password;
  try {
    let response = await fetch(`${apiPath}/auth/login`, {
      body: JSON.stringify(user),
      method: 'POST',
      headers: { "Content-Type": "application/json" }
    });

    if (response.status === 200) {
      let tok = await response.text()
      localStorage.setItem('CurUser', tok);
      setUser(decodeUser(tok));
    }
    else if (response.status !== 401 && response.status !== 403 && response.status !== 500) {
      console.log(await response.text());
    }
    return response.status;


  } catch (err) {
    console.error(err)
    return err;
  }
}

const checkIfUserExists = async (user, banco) => {
  try {
    const result = await fetch(`${apiPath}/auth/checkIfUserExists/${banco}/${user}`)
    if (result.status === 200) {
      return await result.json();
    }
    else {
      console.log(await result.text())
      return result.status
    }
  } catch (err) {
    console.error(err)
    return err;
  }
}

const sendEmailNewPassword = async (cnpj, email, isUser, banco) => {
  try {
    const result = await fetch(`${apiPath}/auth/sendEmail/${banco}/${cnpj}/${email}/${isUser}`)
    if (result.status === 200) {
      return await result.json();
    }
    else {
      console.log(await result.text())
      return result.status
    }
  } catch (err) {
    console.error(err)
    return err;
  }
}

const logoff = () => {
  //authFetch('/auth/logoff', 'GET');
  //setUser(undefined)
  localStorage.removeItem('CurUser');
}

const isLoggedIn = () => localStorage.getItem('CurUser') ? true : false;
const decodeUser = (tok) => { try { return JSON.parse(atob(tok.split('.')[1].replace('-', '+').replace('_', '\\'))); } catch { localStorage.removeItem('CurUser'); return undefined } };
const decodeLogin = () => isLoggedIn() ? decodeUser(localStorage.getItem('CurUser')) : undefined;

const configAuth = (setter) => setUser = setter;

const authFetch = async (path, method = 'GET', data) => {
  let response = await fetch(`${apiPath}${path}`, {
    body: data ? JSON.stringify(data) : undefined,
    method: method,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('CurUser')}`
    },
    redirect: 'follow'
  });

  if (response.status === 403) {
    logoff();
    // eslint-disable-next-line no-restricted-globals
    //location.assign("/")
  }
  if (response.status !== 200) {
    //debugger;
  }
  return new Promise((resolve, reject) => { resolve(response); });
}

export { authFetch, isLoggedIn, decodeLogin, loginAttempt, logoff, configAuth, checkIfUserExists, sendEmailNewPassword };
